import React from 'react'
import { Link } from '@inertiajs/react'
import { linkifyMentions } from '../utils/textUtils'

export default function RenderedMentions({ text, allowedUsernames = null }) {
  const segments = linkifyMentions(text, { allowedUsernames })

  const handleMentionClick = (e) => {
    // Prevent calendar tile click handlers from firing
    e.stopPropagation()
    // Let Inertia Link handle the navigation
  }

  return (
    <>
      {segments.map((segment, index) => {
        if (segment.type === 'mention') {
          return (
            <Link
              key={`${segment.username}-${index}`}
              href={`/users/${segment.username}`}
              className="mention-link text-blue-600 hover:text-blue-800 hover:underline font-medium"
              onClick={(e) => handleMentionClick(e)}
              onMouseDown={(e) => e.stopPropagation()}
              onTouchStart={(e) => e.stopPropagation()}
            >
              {segment.content}
            </Link>
          )
        }
        return <span key={`text-${index}`}>{segment.content}</span>
      })}
    </>
  )
}
